import React from 'react';

const variantClasses = {
  default: 'bg-blue-600 text-white border-transparent hover:bg-blue-700',
  outline:
    'bg-white text-slate-700 border-slate-200 hover:bg-slate-50 hover:text-slate-900',
  ghost: 'bg-transparent border-transparent text-slate-700 hover:bg-slate-100',
  secondary:
    'bg-slate-100 text-slate-800 border-transparent hover:bg-slate-200',
  destructive: 'bg-red-600 text-white border-transparent hover:bg-red-700',
};

const sizeClasses = {
  default: 'h-9 px-4 text-sm',
  sm: 'h-8 px-3 text-xs',
  lg: 'h-10 px-6 text-base',
  icon: 'h-9 w-9 p-0',
};

export const Button = React.forwardRef(function Button(
  { variant = 'default', size = 'default', className = '', children, type = 'button', ...rest },
  ref
) {
  const base =
    'inline-flex items-center justify-center gap-1.5 rounded-md border font-medium transition-colors disabled:pointer-events-none disabled:opacity-50';
  return (
    <button
      ref={ref}
      type={type}
      className={`${base} ${variantClasses[variant] || ''} ${sizeClasses[size] || ''} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
});

export default Button;
